export const ORGANIZATION_COLLECTION: string = 'organization__organization';
